import { Typography, Grid, Button } from '@mui/material';
import { zsHeader, zsHeaderBg } from '@pages/lending/assets';
import ZERO_STATE_BENEFITS from '@pages/lending/constants/ZeroStateBenefits';
import { ExporterLendingInfoProps } from '@pages/lending/types';
import { useTranslation } from 'react-i18next';

const LendingInfo = ({ onAccept, onReject }: ExporterLendingInfoProps) => {
  const { t } = useTranslation();
  return (
    <div className="max-w-screen-lg mx-auto md:mt-32">
      <div className="bg-[#E8F3FF] rounded-tr-xl rounded-tl-xl">
        <div className="flex flex-row px-8 py-5 relative">
          <div className="flex flex-col items-start justify-center gap-2 text-left z-10">
            <Typography variant="h6" className="font-semibold">
              {t('ldExpZsHeader')}
            </Typography>
            <Typography variant="body1" className="text-slate-600">
              {t('ldExpZsDescription')}
            </Typography>
            <div className="flex flex-row gap-3 flex-wrap mt-4 justify-center">
              <Button
                variant="contained"
                className="!bg-[#016bf8] !text-white w-full md:w-auto animate-pulse"
                onClick={onAccept}
              >
                {t('ldExpZsAction')}
              </Button>
              <Button
                variant="outlined"
                color="error"
                className="w-full md:w-auto"
                onClick={onReject}
              >
                {t('ldExpZsReject')}
              </Button>
            </div>
          </div>
          <img
            className="h-[200px] w-auto z-50 hidden sm:block"
            src={zsHeader}
            alt="Zero state header"
          />
          <img
            className="h-full w-auto z-0 absolute top-0 right-0 hidden sm:block"
            src={zsHeaderBg}
            alt="Zero state header"
          />
        </div>
      </div>
      <Grid container>
        {ZERO_STATE_BENEFITS.map((item) => (
          <Grid
            key={item.description}
            item
            xs={12}
            lg={3}
            className="border-[#EBF3FA] border-solid border p-3 text-left"
          >
            {item.icon}
            <Typography variant="body2">{t(item.description)}</Typography>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default LendingInfo;
